// removed by extract-text-webpack-plugin
module.exports = {"createAccountError":"CreateAccountError__createAccountError","title":"CreateAccountError__title","message":"CreateAccountError__message","okButton":"CreateAccountError__okButton","growDotQello":"CreateAccountError__growDotQello","growDotBlue":"CreateAccountError__growDotBlue","growDotGolden":"CreateAccountError__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/CreateAccountError/CreateAccountError.scss
// module id = 1866
// module chunks = 0